/**
 * Shared status + tier badge style maps. Extracted from `App.tsx` per
 * ticket superall-shell-01 so the wallet/loyalty/launcher pages can
 * share a single visual language.
 */

import type { BUStatus } from "./handoff";

export const STATUS_STYLES: Record<BUStatus, string> = {
  live: "bg-emerald-50 text-emerald-700",
  beta: "bg-amber-50 text-amber-700",
  soon: "bg-neutral-100 text-neutral-500",
};

export interface TierStyle {
  bg: string;
  text: string;
  label: { en: string; ar: string };
}

export const TIER_STYLES: Record<string, TierStyle> = {
  bronze: {
    bg: "bg-amber-100",
    text: "text-amber-800",
    label: { en: "Bronze", ar: "برونزي" },
  },
  silver: {
    bg: "bg-neutral-200",
    text: "text-neutral-700",
    label: { en: "Silver", ar: "فضي" },
  },
  gold: {
    bg: "bg-yellow-100",
    text: "text-yellow-800",
    label: { en: "Gold", ar: "ذهبي" },
  },
  platinum: {
    bg: "bg-purple-100",
    text: "text-purple-800",
    label: { en: "Platinum", ar: "بلاتيني" },
  },
};

export function tierStyle(tier: string): TierStyle {
  return TIER_STYLES[tier.toLowerCase()] ?? TIER_STYLES.bronze;
}
